<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.set_money_pwd')" class="nav-bar page-nav">
      <template #left>
        <van-icon name="arrow-left" class="nav-back" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="page-body">
      <div class="field-label">*{{$t("setting.new_pwd")}}</div>
      <div class="item">
        <div class="amount-wrapper">
          <van-field
            v-model="opw"
            type="digit"
            :placeholder="$t('setting.new_pwd_tip')"
          />
        </div>
      </div>

      <div class="field-label">*{{$t("my.old_pwd")}}</div>
      <div class="item">
        <div class="amount-wrapper">
          <van-field
            v-model="tpw"
            type="digit"
            :placeholder="$t('setting.new_again_tip')"
          />
        </div>
      </div>

      <div class="submit-btn" @click="setPayPassword()">{{$t("my.msg42")}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opw: '',
      tpw: '',
      oshowKeyboard: true,
      tshowKeyboard: false,
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    setPayPassword() {
      this.oshowKeyboard = false;
      this.tshowKeyboard = false;
      if(this.opw.length <1){
        this.oshowKeyboard = true;
        this.$toast(this.$t("setting.prefect"));
        return false;
      }
      if(this.tpw.length <1){
        this.tshowKeyboard = true;
        this.$toast(this.$t("setting.prefect"));
        return false;
      }
      if(this.opw !== this.tpw){
        this.$toast(this.$t("setting.prefect"));
        return false;
      }else {
        this.$http({
          method: 'post',
          data:{paypassword:this.opw},
          url: 'user_set_paypw'
        }).then(res=>{
          if(res.code === 200){
            setTimeout(() => {
              this.$toast(res.msg);
            }, 500);
              this.$router.push("Mine")
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
        })
      }
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.radio = res.data.sex;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container {
  min-height: 100%;
  background: #f5f5f5;
}

.page-body {
  padding: 12px 16px 0;
}

.field-label {
  margin: 18px 4px 12px;
  font-size: 24px;
  line-height: 36px;
  color: #7f7f7f;
}

.item {
  width: 100%;
  background: #fff;
}

.amount-wrapper {
  width: 100%;
}

.submit-btn {
  height: 100px;
  width: 100%;
  margin-top: 28px;
  background: linear-gradient(90deg, #6667e8 0%, #5d63e1 100%);
  color: #fff;
  font-size: 34px;
  text-align: center;
  border-radius: 50px;
  line-height: 100px;
  font-weight: 700;
}

.nav-back {
  color: #8795ad;
}

::v-deep .page-nav {
  background: #fff;
}

::v-deep .page-nav .van-nav-bar__title {
  color: #000;
}

::v-deep .page-nav::after {
  border-bottom: 1px solid #ededed;
}

::v-deep .van-cell {
  padding: 24px 20px;
  font-size: 30px;
  line-height: 50px;
}

::v-deep .van-field__control {
  color: #000;
}

::v-deep .van-field__control::placeholder {
  color: #b0b0b0;
}

::v-deep .van-number-keyboard {
  z-index:100;
  width: 100%;
  padding-bottom: 30px;
  background-color: #f2f3f5;
}

::v-deep .van-key {
  height: 100px;
  font-size: 55px;
  line-height: 20px;
  border-radius: 20px;
}

::v-deep .van-key__collapse-icon,
::v-deep .van-key__delete-icon {
  width: 50px;
  height: 50px;
}
</style>
